import { render, staticRenderFns } from "./Fase7.vue?vue&type=template&id=1042e0ea&scoped=true"
import script from "./Fase7.vue?vue&type=script&lang=js"
export * from "./Fase7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042e0ea",
  null
  
)

export default component.exports